<template>
    <v-row class="mb-2 px-2 px-md-4">
        <v-col cols="12">
            <v-card class="pa-4 ayuda-card" :color="'#FBFAF1'" outlined>
                <v-row align="center" dense>
                    <v-col cols="12" md="7">
                        <div class="text-h5 font-weight-bold">Centro de ayuda</div>
                        <div class="text-body-2 grey--text text--darken-1 mt-1">
                            Encuentra respuestas rápidas por tema o busca en preguntas frecuentes.
                        </div>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-text-field
                            v-model="busqueda"
                            dense
                            outlined
                            clearable
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            label="Buscar en ayuda"
                        />
                    </v-col>
                </v-row>

                <v-divider class="my-4" />

                <div class="text-subtitle-1 font-weight-bold mb-3">Temas de ayuda</div>
                <v-row dense>
                    <v-col v-for="tema in temas" :key="tema.id" cols="12" sm="6" md="4" lg="3">
                        <v-card
                            class="tema-card"
                            outlined
                            @click="seleccionarTema(tema.id)"
                            :class="{ 'tema-card--active': temaActivo === tema.id }"
                            :style="temaActivo === tema.id ? { borderColor: tema.color } : null"
                        >
                            <v-card-text>
                                <div class="d-flex align-center">
                                    <v-avatar size="32" :color="tema.color" class="mr-3">
                                        <v-icon small color="white">{{ tema.icono }}</v-icon>
                                    </v-avatar>
                                    <div class="font-weight-medium">{{ tema.titulo }}</div>
                                </div>
                                <div class="text-caption grey--text text--darken-1 mt-2">{{ tema.descripcion }}</div>
                                <v-chip label x-small class="mt-3" :color="tema.color" text-color="white">
                                    {{ tema.preguntas }} preguntas
                                </v-chip>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <component
                    :is="temaActualComponente"
                    :busqueda="busqueda"
                    :color="temaActualColor"
                />

                <v-divider class="my-4" />

                <v-row dense>
                    <v-col cols="12" md="8">
                        <div class="text-subtitle-2 font-weight-bold">¿Necesitas más ayuda?</div>
                        <div class="text-caption grey--text text--darken-1 mt-1">
                            Si no encuentras la respuesta, puedes consultarnos en este correo.
                        </div>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex justify-md-end align-center">
                        <v-chip
                            label
                            link
                            color="#191970"
                            text-color="white"
                            href="mailto:sistemas@rutasmeigas.com?subject=Soporte%20Centro%20de%20Reservas%20Agencias"
                        >
                            <v-icon left small>mdi-email-outline</v-icon>
                            sistemas@rutasmeigas.com
                        </v-chip>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import AyudaTemaCuenta from './ayuda/AyudaTemaCuenta.vue';
import AyudaTemaExpedientes from './ayuda/AyudaTemaExpedientes.vue';
import AyudaTemaGeneral from './ayuda/AyudaTemaGeneral.vue';
import AyudaTemaSolicitudes from './ayuda/AyudaTemaSolicitudes.vue';

export default {
    name: 'AyudaSection',
    components: {
        AyudaTemaCuenta,
        AyudaTemaExpedientes,
        AyudaTemaGeneral,
        AyudaTemaSolicitudes
    },
    data() {
        return {
            busqueda: '',
            temaActivo: 'general',
            temas: [
                {
                    id: 'general',
                    titulo: 'General',
                    descripcion: 'Información general sobre el funcionamiento de la aplicación.',
                    icono: 'mdi-home-outline',
                    color: '#455A64',
                    preguntas: 3,
                    componente: 'AyudaTemaGeneral'
                },
                {
                    id: 'solicitudes',
                    titulo: 'Nueva Solicitud',
                    descripcion: 'Creación de reservas, fechas, habitaciones y tarifas.',
                    icono: 'mdi-plus-box-outline',
                    color: '#2E7D32',
                    preguntas: 6,
                    componente: 'AyudaTemaSolicitudes'
                },
                {
                    id: 'expedientes',
                    titulo: 'Expedientes',
                    descripcion: 'Consulta, filtros y estados de reservas existentes.',
                    icono: 'mdi-file-document-outline',
                    color: '#1976D2',
                    preguntas: 6,
                    componente: 'AyudaTemaExpedientes'
                },
                {
                    id: 'cuenta',
                    titulo: 'Cuenta y acceso',
                    descripcion: 'Inicio de sesión, perfil de agencia y seguridad.',
                    icono: 'mdi-shield-account-outline',
                    color: '#EF6C00',
                    preguntas: 5,
                    componente: 'AyudaTemaCuenta'
                }
            ]
        };
    },
    computed: {
        temaActual() {
            return this.getTemaById(this.temaActivo);
        },
        temaActualColor() {
            return this.temaActual ? this.temaActual.color : '#455A64';
        },
        temaActualComponente() {
            return this.temaActual ? this.temaActual.componente : 'AyudaTemaGeneral';
        }
    },
    methods: {
        seleccionarTema(temaId) {
            this.temaActivo = temaId;
        },
        getTemaById(temaId) {
            return this.temas.find((tema) => tema.id === temaId) || this.temas[0];
        }
    }
};
</script>

<style scoped>
.ayuda-card {
    width: 100%;
}

.tema-card {
    cursor: pointer;
    border: 1px solid #e0e0e0;
    transition: all 0.2s ease;
    min-height: 150px;
}

.tema-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.tema-card--active {
    border-width: 2px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.1);
}
</style>
